.tabs {
  position: relative;
  display: flex;
  align-items: center;

  > a {
    position: relative;
    color: var(--color-muted-foreground) !important;
    transition: color 150ms ease;

    &:hover {
      color: var(--color-foreground) !important;
    }

    &[aria-current="location"] {
      color: var(--color-primary) !important;
    }
  }
}

// One bar under the tabs, placed from the scroll position (LandingSectionTabs): it follows the
// page between sections and settles under the current section's tab. Position follows each
// animation frame directly; transitions would keep restarting and trail behind scrolling.
.indicator {
  position: absolute;
  bottom: 0;
  inset-inline-start: 0;
  width: 0;
  height: 4px;
  border-radius: 999px;
  background: var(--color-primary);
  opacity: 0;
  pointer-events: none;
  transition: opacity 200ms ease;
}
